import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/'); // Redirige a la página principal o a la que prefieras
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        padding: 4,
        backgroundColor: '#f9f9f9',
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src="logo.png"
        alt="Logo"
        sx={{
          width: 100,
          height: 'auto',
          marginBottom: 3,
        }}
      />

      {/* Título */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: '#d32f2f', // Color rojo para indicar error
          marginBottom: 2,
        }}
      >
        Pago Cancelado
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: '#666',
          marginBottom: 4,
          maxWidth: 600,
          textAlign: 'center',
        }}
      >
        Parece que tu pago no se completó. Si necesitas ayuda o deseas volver a
        intentarlo, puedes hacerlo a continuación.
      </Typography>

      {/* Acciones */}
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleRetry}
        sx={{
          textTransform: 'none',
          padding: '10px 20px',
          fontWeight: 500,
        }}
      >
        Volver a Intentar
      </Button>

      {/* Mensaje Final */}
      <Typography
        variant="body2"
        sx={{
          marginTop: 4,
          color: '#777',
          textAlign: 'center',
          maxWidth: 500,
        }}
      >
        Si tienes alguna duda, no dudes en ponerte en contacto con el equipo del
        club. Estamos aquí para ayudarte.
      </Typography>
    </Box>
  );
};

export default PaymentCancel;
